import Route from '@ember/routing/route';

export default class FeaturePacksRoute extends Route {}
